import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';


import { Observable } from 'rxjs';

import {
  ResponseModel,
} from '..';

import { BASE_PATH } from '../variables';
import { Configuration } from '../configuration';
import {LogModel} from "@core/api/model/logModel";


@Injectable()
export class LogService {

  public configuration = new Configuration();
  public defaultHeaders = new HttpHeaders();
  protected basePath = 'https://localhost/v1';

  constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
    if (basePath) {
      this.basePath = basePath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }

  public logsGet<T = LogModel>(body): Observable<ResponseModel<T[]>> {

    return this.httpClient.get<ResponseModel<T[]>>(`${this.basePath}/log?sort=-created_at`,
      {
        params: body
      });
  }

  public logsIdGet<T = LogModel>(id: number): Observable<ResponseModel<T>> {

    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling logsIdGet.');
    }

    return this.httpClient.post<ResponseModel<T>>(`${this.basePath}/log/${encodeURIComponent(String(id))}`, {});
  }
}
